import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import PhoneIcon from '@material-ui/icons/LocalPhoneOutlined';
import LockIcon from '@material-ui/icons/LockOutlined';

import classes from '../../css/getCSS';

const contactInfo = (props) => {
  let selfAddress = null;
  // eslint-disable-next-line
  if (props.profile.contactinfo.self_address && props.profile.contactinfo.self_city &&
    (props.profile.is_editable
      || props.profile.interest.received
      || props.profile.request.received
      || props.profile.interest.accepted
      || props.profile.request.accepted)
  ) {
    selfAddress = `${props.profile.contactinfo.self_address}, ${props.profile.contactinfo.self_city.label}`;
    selfAddress = (
      <Grid item md={12} sm={12} xs={12}>
        <p className={classes.profileCap}>Self/Office Address</p>
        <p className={classes.profileVal}>{selfAddress}</p>
        <br />
      </Grid>
    );
  }

  let selfContact = null;
  if ( props.profile.is_editable
    ) {
    selfContact = (
      <Grid item md={6} sm={6} xs={12}>
        <p className={classes.profileCap}>Candidate contact number</p>
        <p className={classes.profileVal}>{props.profile.contactinfo.self_contact_no}</p>
        <br />
      </Grid>
    );
  }

  
  let residencePhoneNo = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    residencePhoneNo = (
      <Grid item md={6} sm={6} xs={12}>
        <p className={classes.profileCap}>Residence phone no.</p>
        <p className={classes.profileVal}>{props.profile.contactinfo.residence_phone}</p>
        <br />
      </Grid>
    );
  }

  let fatherContact = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    fatherContact = (
      <Grid item md={6} sm={6} xs={12}>
        <p className={classes.profileCap}>Father contact no.</p>
        <p className={classes.profileVal}>{props.profile.contactinfo.father_contact}</p>
        <br />
      </Grid>
    );
  }

  let motherContact = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    motherContact = (
      <Grid item md={6} sm={6} xs={12}>
        <p className={classes.profileCap}>Mother contact no.</p>
        <p className={classes.profileVal}>{props.profile.contactinfo.mother_contact}</p>
        <br />
      </Grid>
    );
  }

  let familyResidenceAddress = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    familyResidenceAddress = (
      <Grid item md={12} sm={12} xs={12}>
        <p className={classes.profileCap}>Family Residence Address</p>
        <p className={classes.profileVal}>
          {props.profile.contactinfo.family_address},&nbsp;
          {props.profile.contactinfo.family_city
            ? props.profile.contactinfo.family_city.label : '-'}
        </p>
        <br />
      </Grid>
    );
  }

  let noOfRooms = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    noOfRooms = (
      <Grid item md={6} sm={6} xs={12}>
        <p className={classes.profileCap}>No. of Rooms / BHK</p>
        <p className={classes.profileVal}>{props.profile.contactinfo.rooms_count}</p>
        <br />
      </Grid>
    );
  }

  let residenceArea = null;
  if ( props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted) {
    residenceArea = (
      <Grid item md={6} sm={6} xs={12}>
        <p className={classes.profileCap}>Area in sqft.</p>
        <p className={classes.profileVal}>{props.profile.contactinfo.residence_area} sqft</p>
        <br />
      </Grid>
    );
  }

  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('contactinfo')}>Edit</Button>
    );
  }

  let contactinfo = null;
  // eslint-disable-next-line
  if (props.profile.is_editable
    || props.profile.interest.received
    || props.profile.request.received
    || props.profile.interest.accepted
    || props.profile.request.accepted
    || true
  ) {
    contactinfo = (
      <React.Fragment>
        {selfAddress}
        {selfContact}
        {familyResidenceAddress}
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Location</p>
          <p className={classes.profileVal}>{props.profile.contactinfo.location}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Type of Residence</p>
          <p className={classes.profileVal}>
            {props.profile.contactinfo.residence_type
              ? props.profile.contactinfo.residence_type.label : '-'}
          </p>
          <br />
        </Grid>
        {residencePhoneNo}
        {fatherContact}
        {motherContact}
      </React.Fragment>
    );
  } else {
    let selfCity = null;
    if (props.profile.contactinfo.self_address && props.profile.contactinfo.self_city) {
      selfCity = (
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>City Residence city</p>
          <p className={classes.profileVal}>
            {props.profile.contactinfo.self_city
              ? props.profile.contactinfo.self_city.label : '-'}
          </p>
          <br />
        </Grid>
      );
    }
    contactinfo = (
      <React.Fragment>
        {selfCity}
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Family residence city</p>
          <p className={classes.profileVal}>
            {props.profile.contactinfo.family_city
              ? props.profile.contactinfo.family_city.label : '-'}
          </p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Location</p>
          <p className={classes.profileVal}>{props.profile.contactinfo.location}</p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Family city</p>
          <p className={classes.profileVal}>
            {props.profile.contactinfo.family_city
              ? props.profile.contactinfo.family_city.label : '-'}
          </p>
          <br />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Type of Residence</p>
          <p className={classes.profileVal}>
            {props.profile.contactinfo.residence_type
              ? props.profile.contactinfo.residence_type.label : '-'}
          </p>
          <br />
        </Grid>
        {noOfRooms}
        {residenceArea}
        <Grid item md={6} sm={6} xs={12}>
          <p className={classes.profileCap}>Area in sqft.</p>
          <p className={classes.profileVal}>{props.profile.contactinfo.residence_area} sqft</p>
          <br />
        </Grid>
        <Grid item md={12} sm={12} xs={12} align="center" style={{ padding: '20px' }}>
          <LockIcon />
          <Typography variant="body1">
            Full Contact details including phone numbers are locked!
            <br />
            The candidate must accept your interest or request to be able to view the details.
          </Typography>
        </Grid>
      </React.Fragment>
    );
  }


  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <PhoneIcon className={classes.titleIcon} />
          Contact Info
        </Typography>
        <br />
        <Grid container>
          {contactinfo}
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default contactInfo;



// WEBPACK FOOTER //
// ./src/profile/components/ContactInfo.js